import { RootState } from "../../../../models";
import { LoadingState } from "../../../../models/state";

export const getLoading: (state: RootState) => LoadingState = (state) => state.loading;
export const getPending: (state: RootState) => string[] = (state) => getLoading(state)?.pending || [];
export const isLoading: (state: RootState) => boolean = (state) => getPending(state).length > 0;
export const isTypeLoading: (state: RootState, type: string) => boolean = (state, type) =>
    getPending(state).includes(type);
